<template>
  <pagefra>
    <div
      class="monitor"
      @click="hideLiftTable"
      v-loading.fullscreen.lock="fullLoading"
      element-loading-background="rgba(0, 0, 0, 0.5)"
    >
      <el-button
        class="flexTabs-rtbtn"
        type="text"
        size="small"
        icon="el-icon-refresh"
        @click="reconnect"
        :disabled="monitorType == -1"
        >{{ $l("重新连接") }}
      </el-button>
      <el-tabs v-model="activeName" class="flexTabs">
        <el-tab-pane :label="$l('电梯列表')" name="list">
          <panel type="toolbar">
            <div class="toolbar">
              <el-form
                class="toolbar-form"
                :inline="true"
                v-model="form"
                label-width
              >
                <!-- <el-form-item label="所属区域">
              <areaCascader
                ref="ac"
                :multiple="true"
                :checkStrictly="true"
              ></areaCascader>
            </el-form-item> -->
                <el-form-item :label="$l('所属城市')">
                  <el-input
                    v-model="form.city"
                    :placeholder="$l('所属城市')"
                  ></el-input>
                </el-form-item>
                <el-form-item :label="$l('地盘名称')">
                  <el-input
                    v-model="form.domainName"
                    :placeholder="$l('地盘名称')"
                  ></el-input>
                </el-form-item>
                <el-form-item :label="$l('工号')">
                  <el-input
                    v-model="form.jobNum"
                    :placeholder="$l('工号')"
                  ></el-input>
                </el-form-item>
                <el-form-item :label="$l('大楼名称')">
                  <el-input
                    v-model="form.buildingName"
                    :placeholder="$l('大楼名称')"
                  ></el-input>
                </el-form-item>
                <el-form-item :label="$l('注册代码')">
                  <el-input
                    v-model="form.registerCode"
                    :placeholder="$l('注册代码')"
                  ></el-input>
                </el-form-item>
                <el-form-item :label="$l('电梯类型')">
                  <el-select
                    v-model="form.elevatorType"
                    :placeholder="$l('电梯类型')"
                  >
                    <el-option :label="$l('电梯类型')" value></el-option>
                    <el-option :label="$l('直梯')" value="直梯"></el-option>
                    <el-option :label="$l('扶梯')" value="扶梯"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="监控状态">
                  <el-select
                    v-model="form.monitorStatus"
                    :placeholder="$l('监控状态')"
                  >
                    <el-option :label="$l('全部')" value=""></el-option>
                    <el-option :label="$l('正常监视')" value="1"></el-option>
                    <el-option :label="$l('异常')" value="0"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button
                    icon="el-icon-search"
                    type="em"
                    circle
                    @click="search"
                  ></el-button>
                  <el-button
                    v-if="monitorType == 2"
                    type="primary"
                    icon="el-icon-back"
                    round
                    @click="backMultiMonitor()"
                    >{{ $l("返回多梯监视") }}
                  </el-button>
                </el-form-item>
              </el-form>
              <div class="toolbar-btn">
                <el-button
                  type="primary"
                  icon="el-icon-monitor"
                  round
                  @click="monitor(1)"
                  >{{ $l("多梯监视") }}
                </el-button>
                <el-button
                  type="em"
                  icon="el-icon-download"
                  round
                  @click="exportElevator"
                  v-if="hasPermission('导出')"
                  >{{ $l("导出") }}
                </el-button>
                <!-- <el-button
                  icon="el-icon-arrow-down"
                  circle
                  @click.stop="toggleLiftTable"
                  @mouseenter.native="showLiftTable"
                  :class="{ rotate: isLiftTableShow }"
                ></el-button> -->
              </div>
            </div>
          </panel>

          <!-- <panel
            class="panel-table panel-liftList"
            v-show="isLiftTableShow"
            id="panel-liftList"
          > -->
          <panel class="panel-table">
            <div class="panel-table__table">
              <el-table
                ref="filterTable"
                :data="tableData"
                highlight-current-row
                height="100%"
                style="width: 100%; z-index: 1000"
                v-loading.lock="loading"
                :element-loading-text="$l('加载中')"
                @row-dblclick="rowDblClick"
                @select="selectChange"
                @select-all="selectChange"
              >
                <el-table-column
                  type="selection"
                  min-width="55"
                ></el-table-column>
                <el-table-column
                  type="index"
                  :label="$l('序号')"
                  min-width="80"
                  align="center"
                ></el-table-column>
                <el-table-column
                  :label="$l('城市')"
                  prop="city"
                  align="center"
                  min-width="120"
                  :formatter="cityFormatter"
                ></el-table-column>
                <el-table-column
                  :label="$l('地盘名称')"
                  prop="domainName"
                  align="center"
                  min-width="150"
                ></el-table-column>
                <el-table-column
                  :label="$l('大楼名称')"
                  prop="buildingName"
                  align="center"
                  min-width="150"
                ></el-table-column>
                <el-table-column
                  :label="$l('梯号')"
                  prop="elevatorNum"
                  align="center"
                  min-width="120"
                ></el-table-column>
                <el-table-column
                  :label="$l('工号')"
                  prop="jobNum"
                  align="center"
                  min-width="120"
                ></el-table-column>
                <el-table-column
                  :label="$l('电梯类型')"
                  prop="elevatorType"
                  align="center"
                  min-width="120"
                  :formatter="elevatorTypeFormatter"
                ></el-table-column>
                <el-table-column
                  :label="$l('电梯品牌')"
                  prop="brand"
                  align="center"
                  min-width="120"
                  :formatter="elevatorBrandFormatter"
                ></el-table-column>
                <el-table-column
                  :label="$l('梯龄')"
                  prop="elevatorAge"
                  align="center"
                  min-width="100"
                ></el-table-column>
                <el-table-column
                  :label="$l('注册代码')"
                  prop="registerCode"
                  align="center"
                  min-width="120"
                ></el-table-column>
                <el-table-column
                  :label="$l('设置')"
                  min-width="80"
                  header-align="center"
                  align="center"
                  fixed="right"
                  v-if="hasPermission('设置')"
                >
                  <template slot-scope="scope">
                    <el-button
                      @click.native.prevent="showSetting(scope.row)"
                      type="primary"
                      light
                      circle
                      icon="el-icon-setting"
                    >
                    </el-button>
                  </template>
                </el-table-column>
                <!-- <el-table-column
                  :label="$l('远程设置')"
                  min-width="80"
                  header-align="center"
                  align="center"
                  fixed="right"
                  v-if="hasPermission('远程设置')"
                >
                  <template slot-scope="scope">
                    <el-button
                      v-if="scope.row.elevatorType == '扶梯'"
                      @click.native.prevent="showEscalatorSetting(scope.row)"
                      type="primary"
                      light
                      circle
                    >
                      <svgicon name="remote"></svgicon>
                    </el-button>
                  </template>
                </el-table-column> -->
                <el-table-column
                  :label="$l('视频监控')"
                  min-width="80"
                  header-align="center"
                  align="center"
                  fixed="right"
                  v-if="hasPermission('视频监控')"
                >
                  <template slot-scope="scope">
                    <!-- <svgicon
                      name="camera"
                      v-if="scope.row.deviceType"
                      @click="playVideo(2, scope.row)"
                      style="
                        width: 16px;
                        height: 16px;
                        color: #e56a6a;
                        cursor: pointer;
                      "
                    ></svgicon> -->
                    <el-button
                      type="primary"
                      light
                      circle
                      v-if="scope.row.deviceType"
                      @click.native.prevent="playVideo(2, scope.row)"
                      class="table-icon"
                    >
                      <svgicon name="monitor" class></svgicon>
                    </el-button>
                  </template>
                </el-table-column>
                <el-table-column
                  :label="$l('监控状态')"
                  prop="isactive"
                  fixed="right"
                  align="center"
                  width="120"
                >
                  <template slot-scope="scope">
                    <a
                      v-if="scope.row.isactive == 1"
                      @click="rowDblClick(scope.row)"
                    >
                      <span class="link-icon">
                        <svgicon name="jianshi"></svgicon>
                      </span>
                      <span style="">{{ $l("正常监视") }} </span>
                      <!-- <img :src="monitorStatusImgUrl" alt="" /> -->
                    </a>
                    <div v-else>
                      <span class="text-warning" @click="rowDblClick(scope.row)">{{ $l("异常") }} </span>
                      <el-button
                        type="primary"
                        light
                        circle
                        size="mini"
                        icon="el-icon-refresh"
                        class="table-icon"
                        :loading="scope.row.refreshing"
                        @click.native.prevent="refreshStatus(scope.row)"
                      ></el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pagination">
              <el-pagination
                :current-page="pageConfig.currentPage"
                :page-sizes="pageConfig.pageSizes"
                :page-size="pageConfig.pageSize"
                :total="pageConfig.total"
                @size-change="handlePageSizeChange"
                @current-change="handleCurrentPageChange"
                layout="total, sizes, prev, pager, next, jumper, slot"
              >
                <!-- <template v-slot>
                  <el-button
                    class="export-button"
                    @click="exportElevator"
                    v-if="hasPermission('导出')"
                    >{{ $l("导出") }}
                  </el-button>
                </template> -->
              </el-pagination>
            </div>
          </panel>
        </el-tab-pane>
        <el-tab-pane :label="$l('电梯监视')" name="single">
          <!-- escalator -->
          <el-row
            type="flex"
            :gutter="basePadding"
            v-show="realElevatorDataList.length > 0"
            v-for="c in countList"
            :key="c + 'escalator'"
          >
            <el-col
              :span="monitorType != 1 ? 12 : 8"
              v-for="item in realElevatorDataList.slice(c * 3, c * 3 + 3)"
              :key="item.jobNum"
            >
              <panel
                type="colorful"
                footer
                class="statePanel"
                height="490px"
                @dblclick.native="singleMonitor(item)"
              >
                <div class="rtTools">
                  <svgicon
                    name="camera"
                    v-if="item.deviceType && hasPermission('视频监控')"
                    @click="playVideo(1, item)"
                  ></svgicon>
                  <svgicon
                    name="intercom"
                    v-if="
                      item.elevatorType == '直梯' &&
                      hasPermission('对讲') &&
                      intercomData
                    "
                    @click="intercom()"
                  ></svgicon>
                  <svgicon name="map2" @click="openMap(item)"></svgicon>
                </div>

                <div class="statePanel-info" style="clear: both">
                  <svgicon
                    v-show="item.RunDirection"
                    name="state_escalator"
                    class="statePanel-tag statePanel-tag--escalator"
                    :class="item.RunDirection == 1 ? 'svg-down' : ''"
                  >
                  </svgicon>

                  <div
                    class="statePanel-curFloor"
                    v-show="item.elevatorType == '直梯'"
                    :class="item.RunDirection ? 'statePanel-floor' : ''"
                  >
                    {{ $l("当前楼层") }}

                    <em class="floorNum">{{ item | realFloor }}</em>
                  </div>
                  <div
                    style="height: 30px"
                    v-show="item.elevatorType !== '直梯'"
                  >
                    <!-- 占位用 -->
                  </div>
                  <h2 :title="item.domainName">
                    {{ item.domainName | defaultValue | subString }}
                  </h2>
                  <el-row
                    type="flex"
                    justify="space-between"
                    class="longtext"
                    v-if="item.isWrap"
                  >
                    <span>
                      <b>{{ item.buildingName | defaultValue }}</b>
                      {{ $l("栋") }}
                    </span>
                    <span>
                      <b>{{ item.elevatorNum | defaultValue }}</b>
                      {{ $l("梯") }}
                    </span>
                  </el-row>
                  <el-row type="flex" justify="space-between" v-else>
                    <span>
                      <b>{{ item.buildingName | defaultValue }}</b>
                      {{ $l("栋") }}
                    </span>
                    <span>
                      <b>{{ item.elevatorNum | defaultValue }}</b>
                      {{ $l("梯") }}
                    </span>
                  </el-row>
                </div>
                <div class="statePanel-detail-fra">
                  <table class="statePanel-detail">
                    <tr>
                      <td width="50%">
                        <h4>{{ $l("出厂编号") }}</h4>
                        <p>{{ item.jobNum | defaultValue }}</p>
                      </td>
                      <td>
                        <h4></h4>
                        <p></p>
                      </td>
                    </tr>
                    <tr>
                      <td width="50%">
                        <h4>{{ $l("品牌") }}</h4>
                        <p>{{ $l(item.brand) | defaultValue }}</p>
                      </td>
                      <td>
                        <h4>{{ $l("梯龄") }}</h4>
                        <p>
                          {{ item.elevatorAge | defaultValue }}{{ $l("年") }}
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <h4>{{ $l("注册代码") }}</h4>
                        <p>{{ item.registerCode | defaultValue }}</p>
                      </td>
                      <td>
                        <h4>{{ $l("城市") }}</h4>
                        <p>{{ item.city | defaultValue }}</p>
                      </td>
                    </tr>
                  </table>
                </div>

                <tr
                  class="energy"
                  v-if="item.elevatorType == '直梯' && energyObj"
                >
                  <td>
                    <p>
                      {{ $l("昨日减少CO2排放") }}
                      {{ energyObj.yesterday | defaultValue }}
                    </p>
                  </td>
                  <td>
                    <p>
                      {{ $l("当月累计减少CO2排放") }}
                      {{ energyObj.month | defaultValue }}
                    </p>
                  </td>
                </tr>
                <div
                  class="energy-bar"
                  :title="energy"
                  v-else-if="
                    realElevatorDataList[0].data &&
                    realElevatorDataList[0].data.WeightPercentHour != undefined
                  "
                >
                  <div
                    v-for="index in 10"
                    :key="index"
                    class="energy-item"
                    :class="{
                      filled:
                        index <=
                        realElevatorDataList[0].data.WeightPercentHour * 0.1,
                    }"
                  ></div>
                </div>
                <div class="stateList" slot="footer" v-show="monitorType != 1">
                  <h2>{{ $l("运行状态说明") }}</h2>
                  <ul>
                    <li class="stateList-item">
                      <span class="text-warning" v-if="connectStatus == 1"
                        >{{ $l("正在请求与电梯连接监控，请稍候") }}
                      </span>
                      <span v-else-if="connectStatus == 2"
                        >{{ $l("电梯正在监控中，最后上线时间：") }}
                        {{ item.OnlineTime }}</span
                      >
                      <!-- <span
                    >因电梯机房内电信运营商信号因素，监控信号与现场实际运行存在3秒左右的延迟现象，属于功能正常范围</span
                  > -->
                    </li>
                  </ul>
                </div>
                <lottie
                  v-if="item.elevatorType == '扶梯'"
                  :options="defaultOptions"
                  :style="{
                    width: monitorType == 1 ? '220px' : '320px',
                    height: monitorType == 1 ? '180px' : '320px',
                    marginRight: monitorType == 1 ? '-200px' : '',
                  }"
                  v-on:animCreated="handleAnimation($event, item.jobNum)"
                  :class="
                    monitorType == 1 ? 'statePanel-imgMuti' : 'statePanel-img'
                  "
                />
                <div
                  v-if="item.elevatorType == '直梯'"
                  class="statePanel-img"
                  :style="
                    monitorType != 1 ? '' : 'margin-right: -174px !important;'
                  "
                >
                  <svgicon
                    name="imgLift"
                    :original="true"
                    class="statePanel-img--lift"
                    :width="monitorType != 1 ? '320' : '180'"
                    :height="monitorType != 1 ? '320' : '220'"
                    :class="item.DoorState == undefined ? '' : item.DoorState"
                  ></svgicon>
                  <div
                    :class="[
                      item.DoorState == undefined ? '' : item.DoorState,
                      monitorType != 1 ? 'liftInset' : 'liftInsetMuti',
                      isTransition ? 'lift_transition' : '',
                    ]"
                  ></div>
                </div>
              </panel>
            </el-col>

            <el-col
              :span="12"
              v-show="
                monitorType != 1 &&
                c == 0 &&
                realElevatorDataList[0].elevatorType == '直梯'
              "
            >
              <panel
                type="gray"
                :title="$l('运行状态')"
                icon="lift2"
                height="490px"
              >
                <ul class="signal">
                  <li
                    :class="[
                      'signal-item',
                      item.value && item.value == '1' ? 'on' : '',
                    ]"
                    v-for="(item, index) in realElevatorDataList.length != 1
                      ? []
                      : realElevatorDataList[0].data
                      ? realElevatorDataList[0].data.RunStatus
                        ? realElevatorDataList[0].data.RunStatus.concat(
                            realElevatorDataList[0].data.DeviceStatus
                          )
                        : []
                      : []"
                    :key="index"
                  >
                    <span
                      v-if="hasMonitorFieldPermission('run#' + item.name)"
                      :title="$l(showDesc(item.name, item.value))"
                      >{{ $l(item.name) }}</span
                    >
                  </li>
                </ul>
              </panel>
            </el-col>

            <el-col
              :span="12"
              v-show="
                monitorType != 1 &&
                c == 0 &&
                realElevatorDataList[0].elevatorType == '扶梯'
              "
            >
              <panel
                type="gray"
                :title="$l('工号信息')"
                icon="gh_info"
                height="160px"
              >
                <div class="info-box">
                  <div class="item">
                    <label>{{ $l("提升高度：") }} </label>
                    <span>{{ jobNumInfo.tsgd }}</span>
                  </div>
                  <div class="item">
                    <label>{{ $l("主机功率：") }} </label>
                    <span>{{ jobNumInfo.zjgl }}</span>
                  </div>
                  <div class="item">
                    <label>{{ $l("变频器功率：") }} </label>
                    <span>{{ jobNumInfo.bpqgl }}</span>
                  </div>
                  <div class="item">
                    <label>{{ $l("逻辑程序号：") }} </label>
                    <span>{{ jobNumInfo.ljcxh }}</span>
                  </div>
                  <div class="item">
                    <label>{{ $l("安全程序号：") }} </label>
                    <span>{{ jobNumInfo.aqcxh }}</span>
                  </div>
                  <div class="item">
                    <label>{{ $l("变频程序号：") }} </label>
                    <span>{{ jobNumInfo.bpcxh }}</span>
                  </div>
                </div>
              </panel>
              <panel
                type="gray"
                :title="$l('运行状态')"
                icon="lift2"
                height="305px"
                style="margin-bottom: 25px"
              >
                <ul class="signal">
                  <li
                    :class="[
                      'signal-item',
                      item.value && item.value == '1' ? 'on' : '',
                    ]"
                    v-for="(item, index) in realElevatorDataList.length != 1
                      ? []
                      : realElevatorDataList[0].data
                      ? realElevatorDataList[0].data.RunStatus
                        ? realElevatorDataList[0].data.RunStatus.concat(
                            realElevatorDataList[0].data.DeviceStatus
                          )
                        : []
                      : []"
                    :key="index"
                  >
                    <span
                      v-if="hasMonitorFieldPermission('run#' + item.name)"
                      :title="showDesc(item.name, item.value)"
                      >{{ $l(item.name) }}</span
                    >
                  </li>
                </ul>
              </panel>
            </el-col>

            <!-- <el-col :span="12" v-show="monitorType != 1 && c == 0">
          <panel type="gray" title="电梯与人员定位" icon="map" height="490px">
            <div style="position: relative; height: 426px">
              <mapPersonList
                :data="personList"
                :status="personLoadingStatus"
              ></mapPersonList>
              <div id="personLocationMap" style="height: 426px"></div>
            </div>
          </panel>
        </el-col> -->
          </el-row>
          <template
            v-if="
              monitorType != 1 &&
              realElevatorDataList.length != 0 &&
              realElevatorDataList[0].elevatorType == '扶梯'
            "
          >
            <el-row type="flex" :gutter="basePadding">
              <el-col :span="12" v-if="isExistStatus(3)">
                <panel
                  type="gray"
                  :title="$l('视频分析信息')"
                  icon="camera"
                  height="210px"
                >
                  <ul class="signal signal--primary">
                    <li
                      :class="[
                        'signal-item',
                        item.value && item.value == '1' ? 'on' : '',
                      ]"
                      v-for="(item, index) in realElevatorDataList.length != 1
                        ? []
                        : realElevatorDataList[0].data
                        ? realElevatorDataList[0].data.VideoStatus
                        : []"
                      :key="index"
                    >
                      <span :title="showDesc(item.name, item.value)">{{
                        item.name
                      }}</span>
                    </li>
                  </ul>
                </panel>
              </el-col>
              <el-col :span="isExistStatus(3) ? 12 : 24">
                <panel
                  type="gray"
                  :title="$l('故障状态')"
                  icon="display_fault"
                  height="210px"
                >
                  <ul class="signal signal--primary">
                    <li
                      :class="[
                        'signal-item',
                        item.value && item.value == '1' ? 'on' : '',
                      ]"
                      v-for="(item, index) in realElevatorDataList.length != 1
                        ? []
                        : realElevatorDataList[0].data
                        ? realElevatorDataList[0].data.FaultStatus
                        : []"
                      :key="index"
                    >
                      <span
                        v-if="hasMonitorFieldPermission('fault#' + item.name)"
                        :title="showDesc(item.name, item.value)"
                        >{{ $l(item.name) }}</span
                      >
                    </li>
                  </ul>
                </panel>
              </el-col>
            </el-row>
            <el-row type="flex" :gutter="basePadding" v-if="isExistStatus(4)">
              <el-col :span="24">
                <panel
                  type="gray"
                  :title="$l('诊断状态')"
                  icon="breakdown"
                  height="310px"
                >
                  <ul class="signal signal--primary">
                    <li
                      :class="[
                        'signal-item',
                        item.value
                          ? item.value == '0'
                            ? 'gray'
                            : item.value == '1'
                            ? 'yellow'
                            : 'red'
                          : '',
                      ]"
                      v-for="(item, index) in realElevatorDataList.length != 1
                        ? []
                        : realElevatorDataList[0].data
                        ? realElevatorDataList[0].data.DiagnosisStatus
                        : []"
                      :key="index"
                    >
                      <span :title="showDesc(item.name, item.value)">{{
                        item.name
                      }}</span>
                    </li>
                  </ul>
                </panel>
              </el-col>
            </el-row>
          </template>
          <el-row type="flex" :gutter="basePadding" v-show="monitorType != 1">
            <el-col
              :span="24"
              v-show="
                realElevatorDataList.length == 1 &&
                realElevatorDataList[0].elevatorType == '直梯'
              "
            >
              <panel
                type="gray"
                :title="$l('故障状态')"
                icon="breakdown"
                height="320px"
              >
                <ul class="signal signal--primary">
                  <li
                    :class="[
                      'signal-item',
                      item.value && item.value == '1' ? 'on' : '',
                    ]"
                    v-for="(item, index) in realElevatorDataList.length != 1
                      ? []
                      : realElevatorDataList[0].data
                      ? realElevatorDataList[0].data.FaultStatus
                      : []"
                    :key="index"
                  >
                    <span
                      v-if="hasMonitorFieldPermission('fault#' + item.name)"
                      :title="showDesc(item.name, item.value)"
                      >{{ $l(item.name) }}</span
                    >
                  </li>
                </ul>
              </panel>
            </el-col>
          </el-row>
          <el-row type="flex" :gutter="basePadding" v-show="monitorType != 1">
            <el-col
              :span="24"
              v-show="
                realElevatorDataList.length > 0 &&
                realElevatorDataList[0].elevatorType == '直梯'
              "
            >
              <panel
                :title="$l('当月报警记录')"
                icon="alarm"
                class="alarmPanel panel-table"
                height="320px"
              >
                <el-table
                  ref="alarmTable"
                  :data="alarmTableData"
                  size="small"
                  tooltip-effect="tableTooltip"
                  highlight-current-row
                  v-loading="alarmLoading"
                  style="width: 100%"
                  height="100%"
                >
                  <el-table-column
                    type="index"
                    :label="$l('序号')"
                    width="80"
                    align="center"
                  ></el-table-column>
                  <el-table-column
                    property="finishDate"
                    :label="$l('报警解除时间')"
                    min-width="100"
                    show-overflow-tooltip
                    header-align="center"
                    align="center"
                    :formatter="finishDateFormatter"
                  ></el-table-column>
                  <el-table-column
                    property="description"
                    :label="$l('故障描述')"
                    min-width="100"
                    header-align="center"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span :title="scope.row.description">{{
                        scope.row.description &&
                        scope.row.description.length > 20
                          ? scope.row.description.substring(0, 20) + "..."
                          : $l(scope.row.description)
                      }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    :label="$l('主微机故障码')"
                    prop="mainFaultCode"
                    align="center"
                    min-width="120"
                  ></el-table-column>
                  <el-table-column
                    :label="$l('变频器故障码')"
                    prop="subFaultCode"
                    align="center"
                    min-width="120"
                  ></el-table-column>
                  <el-table-column
                    :label="$l('是否困人')"
                    prop="boxUp"
                    align="center"
                    min-width="80"
                    :formatter="boxUpFormatter"
                  ></el-table-column>
                  <el-table-column
                    property="alarmDate"
                    :label="$l('发布时间')"
                    min-width="100"
                    show-overflow-tooltip
                    header-align="center"
                    align="center"
                  ></el-table-column>
                </el-table>
              </panel>
            </el-col>
          </el-row>
          <el-row :gutter="basePadding" v-show="monitorType != 1">
            <el-col
              :md="4"
              :lg="3"
              v-for="(item, index) in realElevatorDataList.length != 1
                ? []
                : realElevatorDataList[0].data
                ? realElevatorDataList[0].data.OtherStatus
                : []"
              :key="index"
            >
              <panel
                v-if="
                  hasMonitorFieldPermission('other#' + item.name) &&
                  isShowOutsideCount(item.name)
                "
                :title="$l(item.name)"
                class="valuePanel"
              >
                <b>
                  {{ $l(item.value) | otherStatusFormat(item.name) }}
                </b>
              </panel>
            </el-col>
            <el-col
              :md="4"
              :lg="3"
              v-for="(item, index) in elevatorElec"
              :key="item.name + index"
            >
              <panel type="gray" :title="$l(item.name)" class="valuePanel">
                <b>
                  {{ $l(item.value) }}
                </b>
              </panel>
            </el-col>
            <el-col
              :md="4"
              :lg="3"
              v-for="(item, index) in componentHealthList"
              :key="item.componentName + index"
            >
              <panel
                type="gray"
                :title="$l(item.componentName)"
                class="valuePanel"
              >
                <b>
                  {{ $l(item.status) }}
                </b>
              </panel>
            </el-col>
          </el-row>
        </el-tab-pane>
        <!-- <el-tab-pane label="多梯监视" name="mul">角色管理</el-tab-pane> -->
      </el-tabs>

      <el-dialog
        ref="settingDialog"
        :title="$l('设置')"
        :visible.sync="settingDialogVisible"
        width="640px"
      >
        <el-form
          ref="settingForm"
          :model="settingForm"
          label-width="140px"
          size="medium"
          class="dialog-form"
          :rules="settingRules"
        >
          <el-form-item :label="$l('能量显示')">
            <el-switch v-model="settingForm.energy"></el-switch>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-row type="flex">
            <el-col>
              <el-button round @click="settingDialogVisible = false"
                >{{ $l("取消") }}
              </el-button>
              <el-button round type="primary" @click="submitSetting"
                >{{ $l("确定") }}
              </el-button>
            </el-col>
          </el-row>
        </div>
      </el-dialog>

      <videoMonitor ref="video"></videoMonitor>

      <personLocation
        ref="personLocation"
        :showButton="false"
        :showTrace="false"
        label="电梯与人员定位"
        emptyCoordMsg="电梯坐标未采集，请联系维保单位确认。"
        height="426px"
      ></personLocation>

      <videoIntercom ref="intercom"></videoIntercom>
      <escalatorSettings
        ref="escalatorSettings"
        :data="escalatorData"
      ></escalatorSettings>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import videoMonitor from "@/components/videoMonitor.vue";
import personLocation from "@/components/personLocation.vue";
import videoIntercom from "@/components/videoIntercom.vue";
import escalatorSettings from "@/components/escalatorSettings.vue";
import global from "@/mixins/global.js";
import * as animationData from "@/assets/lottie/escalator.json";

export default {
  name: "monitor",
  mixins: [global],
  components: {
    panel,
    videoMonitor,
    personLocation,
    videoIntercom,
    escalatorSettings,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      activeName: "list",
      isLiftTableShow: false,
      //手扶梯动画
      defaultOptions: { animationData: animationData.default },
      animationSpeed: 1,
      anim: {},
      //表格
      form: {
        pageNum: 0,
        pageSize: 0,
        city: null,
        domainName: "",
        jobNum: "",
        buildingName: "",
        registerCode: "",
        elevatorType: null,
        monitorStatus: null,
        dataPermissionList: [],
      },
      tableData: null,
      loading: false,
      alarmTableData: [],
      alarmLoading: false,
      statusDescList: [],
      style: {
        height: "490px",
      },
      realElevatorDataList: [],
      timer: null,
      isWrap: false, //是否换行
      fullLoading: false,
      monitorStatusImgUrl: require("@/assets/img/monitor.gif"),
      connectStatus: 0, //0:未连接,1:连接中,2:监控中
      animationList: [],
      selectedList: [],
      monitorType: -1, //0：单梯监视，1：多梯监视，2：多梯跳单梯监视
      countList: [],
      jsonData: null, //存放多梯数据
      jobNum: null, //当前监控的电梯工号
      currentRow: null,
      isTransition: false, //是否加载动画
      settingDialogVisible: false,
      settingForm: {
        elevatorId: null,
        jobNum: null,
        energy: false,
      },
      settingRules: {
        deviceSerial: [
          {
            min: 9,
            max: 20,
            message: this.$l("长度在 9 到 20 个字符"),
            trigger: "blur",
          },
        ],
      },
      isOpenDialog: false,
      elevator: null, //当前监控的电梯
      jobNumInfo: {},
      energyObj: {},
      elevatorElec: [],
      componentHealthList: [], //部件当前健康状态列表
      energy: 9,
      intercomData: null, //对讲数据
      escalatorData: null,
    };
  },
  // directives: {
  //   drag(el) {
  //     let oDiv = el; // 当前元素
  //     // let self = this // 上下文
  //     // 禁止选择网页上的文字
  //     document.onselectstart = function () {
  //       return false;
  //     };
  //     oDiv.onmousedown = function (e) {
  //       // 鼠标按下，计算当前元素距离可视区的距离
  //       let disX = e.clientX - oDiv.offsetLeft;
  //       let disY = e.clientY - oDiv.offsetTop;
  //       oDiv.style.cursor = "move";
  //       document.onmousemove = function (e) {
  //         // 通过事件委托，计算移动的距离
  //         let left = e.clientX - disX;
  //         let top = e.clientY - disY;
  //         if (left <= 0) {
  //           left = 0;
  //         } else if (
  //           left >=
  //           oDiv.parentElement.clientWidth - oDiv.offsetWidth
  //         ) {
  //           left = oDiv.parentElement.clientWidth - oDiv.offsetWidth;
  //         }
  //         if (top <= 0) {
  //           top = 0;
  //         } else if (
  //           top >=
  //           oDiv.parentElement.clientHeight - oDiv.offsetHeight
  //         ) {
  //           top = oDiv.parentElement.clientHeight - oDiv.offsetHeight;
  //         }
  //         // 移动当前元素
  //         oDiv.style.right = "unset";
  //         oDiv.style.left = left + "px";
  //         oDiv.style.top = top + "px";
  //       };
  //       document.onmouseup = function (e) {
  //         document.onmousemove = null;
  //         document.onmouseup = null;
  //         oDiv.style.cursor = "default";
  //       };
  //       // return false不加的话可能导致黏连，就是拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
  //       return false;
  //     };
  //   },
  // },
  methods: {
    handlePageSizeChange(val) {
      this.pageConfig.pageSize = val;
      this.initData();
    },
    handleCurrentPageChange(val) {
      this.pageConfig.currentPage = val;
      this.initData();
    },
    handleMonitor(index, row) {},
    handleRefresh(index, row) {},
    refreshStatus(row) {
      if (row.refreshing) {
        return;
      }
      this.$set(row, "refreshing", true);
      this.$http
        .post(this.$apiConfig.search_elevator_url, {
          pageNum: this.pageConfig.currentPage,
          pageSize: this.pageConfig.pageSize,
          pageName: "monitor",
          jobNum: row.jobNum,
        })
        .then((response) => {
          const data = response.data;
          if (data.code == 0 && data.data && data.data.result) {
            const result = data.data.result.filter(
              (t) => t.jobNum == row.jobNum
            );
            if (result.length > 0) {
              this.$set(row, "isactive", result[0].isactive);
            } else {
              this.$message.error(this.$l("未查询到该电梯"));
            }
          }
          this.$set(row, "refreshing", false);
        })
        .catch((error) => {
          this.$set(row, "refreshing", false);
          this.$sentry.captureException(error);
        });
    },
    clearFilter() {
      this.$refs.filterTable.clearFilter();
    },
    search(event) {
      this.pageConfig.currentPage = 1;
      this.initData();
    },
    initData(isShow) {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      this.form.pageNum = this.pageConfig.currentPage;
      this.form.pageSize = this.pageConfig.pageSize;
      this.form.pageName = "monitor";
      this.tableData = [];
      this.loading = true;
      this.$http
        .post(this.$apiConfig.search_elevator_url, this.form)
        .then((response) => {
          this.loading = false;
          let data = response.data;
          if (data.code == 0) {
            this.pageConfig.total = data.data.total;
            this.tableData = data.data.result;
            this.$nextTick(() => {
              if (this.selectedList.length > 0) {
                this.selectedList.forEach((item) => {
                  const rows = this.tableData.filter(
                    (t) => t.jobNum == item.jobNum
                  );
                  if (rows.length == 1) {
                    this.$refs.filterTable.toggleRowSelection(rows[0]);
                  }
                });
              }
            });
            if (
              !this.$store.state.monitorStatusTimer &&
              this.$store.state.monitorStatusTimer != -1
            ) {
              this.openTimer();
            }
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            } else if (isShow == undefined) {
              this.showLiftTable();
            }
          }
        })
        .catch((error) => {
          this.loading = false;
          this.$sentry.captureException(error);
          if (
            !this.$store.state.monitorStatusTimer &&
            this.$store.state.monitorStatusTimer != -1
          ) {
            this.openTimer();
          }
        });
    },
    initAlarmData(jobNum) {
      this.alarmLoading = true;
      this.alarmTableData = [];
      this.$http
        .post(this.$apiConfig.search_jobNum_alarm_url, {
          pageNum: 1,
          pageSize: 10,
          jobNum: jobNum,
          startDate: this.$common.formatCurrentMonth() + "-01 00:00:00",
          endDate: this.$common.formatCurrentDateTime(),
        })
        .then((response) => {
          this.alarmLoading = false;
          let data = response.data;
          if (data.code == 0) {
            this.alarmTableData = data.data.result;
          }
        })
        .catch((error) => {
          this.alarmLoading = false;
          this.$sentry.captureException(error);
        });
    },
    selectChange(selection) {
      selection.forEach((item) => {
        if (
          this.selectedList.filter((t) => t.jobNum == item.jobNum).length == 0
        ) {
          this.selectedList.push(item);
        }
      });
      const arr = this.tableData.filter(
        (t) => selection.filter((t2) => t2.jobNum == t.jobNum).length == 0
      );
      for (let i = 0; i < this.selectedList.length; i++) {
        const jobNum = this.selectedList[i].jobNum;
        if (arr.filter((t) => t.jobNum == jobNum).length == 1) {
          this.selectedList.splice(i, 1);
          i--;
        }
      }
    },
    monitor(monitorType) {
      this.isTransition = false;
      this.monitorType = monitorType;
      if (monitorType == 1) {
        this.currentRow = null;
        const len = this.selectedList.length;
        if (len == 0) {
          this.$message.error("请选择数据");
          return;
        }
        if (len > 6) {
          this.$message.error("最多只能选择6台电梯");
          return;
        }
        // if (
        //   (this.selectedList[0].elevatorType == "直梯" &&
        //     this.selectedList.filter((t) => t.elevatorType == "直梯").length !=
        //       len) ||
        //   (this.selectedList[0].elevatorType == "扶梯" &&
        //     this.selectedList.filter((t) => t.elevatorType == "扶梯").length !=
        //       len)
        // ) {
        //   this.$message.error("只能选择同一类型的电梯");
        //   return;
        // }
        if (this.selectedList.filter((t) => t.isactive != 1).length > 0) {
          this.$message.error(
            this.$l("遥监设备断开，无法实时监视，请及时恢复。")
          );
          return;
        }
        this.$store.commit("siderCollapse");
      }
      if (monitorType == 0) {
        if (this.currentRow.isactive != 1) {
          this.$message.error(
            this.$l("遥监设备断开，无法实时监视，请及时恢复。")
          );
          return;
        }
      }
      this.fullLoading = true;

      this.activeName = "single"; //跳转tab

      if (this.$store.state.ws) {
        this.$store.state.isAutoCloseWS = false;
        this.$store.state.ws.close();
        this.$store.commit("setWS", null);
      }
      window.setTimeout(() => {
        this.isTransition = true;
        this.animationList.forEach((item) => {
          item.anim.stop();
        });
        this.realElevatorDataList = [];
        this.isLiftTableShow = false;
        this.realElevatorDataList =
          this.monitorType == 0
            ? JSON.parse(JSON.stringify([this.currentRow]))
            : JSON.parse(JSON.stringify(this.selectedList));
        this.realElevatorDataList.forEach((item) => {
          const buildingName = item.buildingName;
          const elevatorNum = item.elevatorNum;
          if (buildingName || elevatorNum) {
            var reg = /.*[\u4e00-\u9fa5]+.*$/;
            if (reg.test(elevatorNum) || reg.test(buildingName)) {
              item.isWrap = true;
            } else {
              item.isWrap =
                (elevatorNum && elevatorNum.length > 2) ||
                (buildingName && buildingName.length > 2);
            }
          }
        });
        this.fullLoading = false;
        this.connectStatus = 1;
        this.realMonitor(this.realElevatorDataList, false, (data) => {
          this.connectStatus = 2;
          if (this.monitorType == 2) {
            this.jsonData = data;
          }
          this.realElevatorDataList =
            this.monitorType != 2
              ? JSON.parse(data)
              : JSON.parse(data).filter((t) => t.jobNum == this.jobNum);
          this.countList = [];
          const count = Math.ceil(this.realElevatorDataList.length / 2);
          for (let i = 0; i < count; i++) {
            this.countList.push(i);
          }
          if (
            this.realElevatorDataList.filter((t) => t.elevatorType == "扶梯")
              .length > 0
          ) {
            this.realElevatorDataList
              .filter((t) => t.elevatorType == "扶梯")
              .forEach((item, i) => {
                const arr = this.animationList.filter(
                  (t) => t.jobNum == item.jobNum
                );
                if (arr.length == 1 && arr[0].anim) {
                  const anim = arr[0].anim;
                  if (!item.RunDirection) {
                    anim.stop();
                  } else if (item.RunDirection == 1) {
                    anim.play();
                    anim.setDirection(1);
                  } else if (item.RunDirection == 2) {
                    anim.play();
                    anim.setDirection(-1);
                  }
                }
              });
          }
        });
      }, 1000);
    },
    singleMonitor(item) {
      this.isTransition = false;
      if (this.monitorType == 1) {
        this.fullLoading = true;
        this.monitorType = 2;
        this.elevator = item;
        this.jobNum = item.jobNum;
        this.jsonData = JSON.stringify(this.realElevatorDataList);
        let arr = this.realElevatorDataList.filter(
          (t) => t.jobNum == item.jobNum
        );
        this.setDoorState(arr);
        this.realElevatorDataList = arr;
        this.initAlarmData(item.jobNum);
        window.document.getElementsByClassName("monitor")[0].scrollTo(0, 0);
        window.setTimeout(() => {
          this.isTransition = true;
          this.fullLoading = false;
        }, 1000);
      }
    },
    backMultiMonitor() {
      this.isTransition = false;
      if (this.monitorType == 2) {
        this.fullLoading = true;
        this.monitorType = 1;
        this.jobNum = null;
        let arr = JSON.parse(this.jsonData);
        this.setDoorState(arr);
        this.realElevatorDataList = arr;
        window.setTimeout(() => {
          this.isTransition = true;
          this.fullLoading = false;
        }, 1000);
      }
    },
    rowDblClick(row) {
      this.getIntercomData(row.jobNum);
      this.jobNum = null;
      this.elevator = row;
      this.currentRow = row;
      this.$refs.filterTable.clearSelection();
      this.selectedList = [];
      this.monitor(0);
      this.initAlarmData(row.jobNum);
      if (row.elevatorType == "扶梯") {
        this.getEleInfo(row.jobNum);
        this.elevatorElec = [];
        // this.getComponentHealth(row.jobNum);
      } else {
        this.getElevatorElec(row.jobNum);
        this.energyObj = row.energy ? {} : null;
        row.energy && this.getEnergy(row.jobNum);
      }
      this.activeName = "single"; //跳转tab
    },
    showLiftTable() {
      this.isLiftTableShow = true;
    },
    hideLiftTable(event) {
      var sp = document.getElementById("panel-liftList");
      if (sp) {
        if (!sp.contains(event.target)) {
          if (!this.isOpenDialog) {
            //这句是说如果我们点击到了id为myPanel以外的区域
            this.isLiftTableShow = false;
          } else if (
            !this.$refs.video.dialogStatus() &&
            !this.settingDialogVisible
          ) {
            this.isOpenDialog = false;
          }
        }
      }
    },
    toggleLiftTable() {
      this.isLiftTableShow = !this.isLiftTableShow;
    },
    handleAnimation: function (anim, jobNum) {
      for (let i = 0; i < this.animationList.length; i++) {
        const item = this.animationList[i];
        if (
          !this.realElevatorDataList
            .filter((t) => t.elevatorType == "扶梯")
            .some((t) => t.jobNum == item.jobNum) ||
          item.jobNum == jobNum
        ) {
          this.animationList.splice(i, 1);
          i--;
        }
      }
      if (
        this.realElevatorDataList.filter((t) => t.elevatorType == "扶梯")
          .length != this.animationList.length
      ) {
        const arr = this.realElevatorDataList
          .filter((t) => t.elevatorType == "扶梯")
          .filter((t) => t.jobNum == jobNum);
        if (arr.length > 0) {
          const item = arr[0];
          if (!item.RunDirection) {
            anim.stop();
          } else if (item.RunDirection == 1) {
            anim.play();
            anim.setDirection(1);
          } else if (item.RunDirection == 2) {
            anim.play();
            anim.setDirection(-1);
          }
          this.animationList.push({ anim, jobNum });
        }
      }
    },
    reconnect() {
      if (this.monitorType == 0) {
        this.rowDblClick(this.currentRow);
      } else if (this.monitorType > 0) {
        this.monitor(1);
      }
    },
    getStatusDescData() {
      this.$http
        .get(this.$apiConfig.get_status_desc_url)
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            this.statusDescList = result.data;
          }
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    showDesc(name, value) {
      let arr = this.statusDescList.filter((t) => t.statusName == name);
      if (arr.length == 1) {
        return value == "1" ? arr[0].value1 : arr[0].value0;
      }
      return name;
    },
    allowMonitor() {
      if (this.$store.state.user.monitor) {
        if (
          !this.$store.state.allDayMonitorTimer &&
          this.$store.state.allDayMonitorTimer != -1
        ) {
          this.$store.state.allDayMonitorTimer = window.setTimeout(() => {
            this.$http
              .get(this.$apiConfig.allow_all_day_monitor_url)
              .then((response) => {
                if (this.$store.state.allDayMonitorTimer != -1) {
                  this.$store.state.allDayMonitorTimer = null;
                  this.allowMonitor();
                }
              })
              .catch((error) => {
                this.allowMonitor();
              });
          }, 300000);
        }
      }
    },
    showSetting(row) {
      this.isOpenDialog = true;
      this.settingDialogVisible = true;
      this.settingForm.energy = row.energy;
      this.settingForm.elevatorId = row.elevatorId;
      this.settingForm.jobNum = row.jobNum;
    },
    showEscalatorSetting(row) {
      if (row.elevatorType != "扶梯") {
        this.message(1, "请选择扶梯");
      }
      this.escalatorData = row;
      this.$refs.escalatorSettings.open(row.jobNum);
    },
    submitSetting() {
      this.fullLoading = true;
      this.$http
        .post(this.$apiConfig.save_elevator_energy_url, this.settingForm)
        .then((response) => {
          this.fullLoading = false;
          let result = response.data;
          this.message(result.code, result.msg);
          if (result.code == 0) {
            this.settingDialogVisible = false;
            this.search();
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    playVideo(type, row) {
      if (row != undefined) {
        this.isOpenDialog = true;
      }
      row.playType = 1;
      row.pageInfo = "PC端-实时监视-视频监控";
      this.$refs.video.playVideo(type, row);
    },
    intercom() {
      this.$refs.intercom.play(this.intercomData);
    },
    getIntercomData(jobNum) {
      this.intercomData = null;
      this.$http
        .get(this.$apiConfig.get_intercom_url, {
          params: {
            jobNum: jobNum,
          },
        })
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            this.intercomData = result.data;
          }
        })
        .catch((error) => {
          this.$sentry.captureException(error);
        });
    },
    closeTimer() {
      if (
        this.$store.state.monitorStatusTimer &&
        this.$store.state.monitorStatusTimer != -1
      ) {
        window.clearTimeout(this.$store.state.monitorStatusTimer);
      }
      this.$store.state.monitorStatusTimer = -1;
    },
    openTimer() {
      this.$store.state.monitorStatusTimer = window.setTimeout(() => {
        if (this.$store.state.monitorStatusTimer != -1) {
          this.$store.state.monitorStatusTimer = null;
          this.initData(false);
        }
      }, window.config.monitorStatusTimerInterval);
    },
    openMap(row) {
      this.$refs.personLocation.open(row);
    },
    getEleInfo(jobNum) {
      this.$http
        .get(this.$apiConfig.get_escalator_info, {
          params: {
            jobNum,
          },
        })
        .then((response) => {
          const result = response.data;
          if (result.code == 0 && result.data) {
            this.jobNumInfo = result.data;
          }
        })
        .catch((error) => {
          console.log(error);
          this.$sentry.captureException(error);
        });
    },
    getComponentHealth(jobNum) {
      this.$http
        .get(this.$apiConfig.get_component_health_url, {
          params: {
            jobNum,
          },
        })
        .then((response) => {
          const result = response.data;
          if (result.code == 0 && result.data) {
            this.componentHealthList = result.data;
          }
        })
        .catch((error) => {
          console.log(error);
          this.$sentry.captureException(error);
        });
    },
    getEnergy(jobNum) {
      this.$http
        .get(this.$apiConfig.get_energy, {
          params: {
            jobNum,
          },
        })
        .then((response) => {
          const result = response.data;
          if (result.code == 0 && result.data) {
            this.energyObj = result.data;
          }
        })
        .catch((error) => {
          console.log(error);
          this.$sentry.captureException(error);
        });
    },
    getElevatorElec(jobNum) {
      this.$http
        .get(this.$apiConfig.get_elevator_elec, {
          params: {
            jobNum,
          },
        })
        .then((response) => {
          const result = response.data;
          if (result.code == 0 && result.data) {
            this.elevatorElec = [
              {
                name: "匀速段平均输出电流（A）",
                code: "constantspdelec",
              },
              {
                name: "运行时输出电流最大值（A）",
                code: "runingmaxelec",
              },
              {
                name: "运行时母线电压最大值（V）",
                code: "runingmaxbusv",
              },
              {
                name: "运行时母线电压最小值（V）",
                code: "runingminbusv",
              },
              {
                name: "启动前母线电压最大值（V）",
                code: "startmaxbusv",
              },
              {
                name: "启动前母线电压最小值（V）",
                code: "startminbusv",
              },
              {
                name: "启动补偿电流（A）",
                code: "zerospdelec",
              },
            ].map((v) => {
              return {
                name: v.name,
                value: result.data[v.code],
              };
            });
          } else {
            this.elevatorElec = [];
          }
        })
        .catch((error) => {
          this.elevatorElec = [];
          console.log(error);
          this.$sentry.captureException(error);
        });
    },
    isExistStatus(type) {
      if (
        this.realElevatorDataList.length != 1 ||
        !this.realElevatorDataList[0].data
      ) {
        return false;
      }
      if (type == 3) {
        return (
          this.realElevatorDataList[0].data.VideoStatus &&
          this.realElevatorDataList[0].data.VideoStatus.length > 0
        );
      } else if (type == 4) {
        return (
          this.realElevatorDataList[0].data.DiagnosisStatus &&
          this.realElevatorDataList[0].data.DiagnosisStatus.length > 0
        );
      }
      return true;
    },
    cityFormatter(row) {
      const city = row.city;
      if (!city) {
        return "";
      } else {
        return this.$l(city);
      }
    },
    elevatorTypeFormatter(row) {
      return this.$l(row.elevatorType);
    },
    elevatorBrandFormatter(row) {
      return this.$l(row.brand);
    },
    finishDateFormatter(row) {
      if (row.boxUp == "是") {
        return row.rescueTime ? row.rescueTime : row.finishDate;
      } else {
        return row.finishDate ? row.finishDate : row.rescueTime;
      }
    },
    boxUpFormatter(row) {
      if (row.boxUp) {
        return this.$l(row.boxUp);
      }
      return this.$l("否");
    },
    exportElevator() {
      this.fullLoading = true;
      let filename =
        "实时监视_" + this.$common.formatCurrentDateTime(false) + ".xlsx";
      this.$http({
        url: this.$apiConfig.export_elevator_url,
        method: "post",
        responseType: "blob",
        data: this.form,
      })
        .then((response) => {
          this.fullLoading = false;
          const status = response.status;
          if (status != 200) {
            this.message(
              1,
              status == 201
                ? "导出失败"
                : status == 202
                ? "没有数据"
                : "数据量过大"
            );
            return;
          }
          const data = response.data;
          var blob = new Blob([data]);
          //判断是不是ie的浏览器
          if (!!window.ActiveXObject || "ActiveXObject" in window) {
            window.navigator.msSaveOrOpenBlob(blob, filename);
          } else {
            var url = window.URL.createObjectURL(blob);
            var aLink = document.createElement("a");
            aLink.style.display = "none";
            aLink.download = filename;
            aLink.href = url;
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink); // 下载完成移除元素
            window.URL.revokeObjectURL(url); // 释放掉blob对象
          }
        })
        .catch((error) => {
          this.fullLoading = false;
          this.errorMessage(0);
          this.$sentry.captureException(error);
        });
    },
    isShowOutsideCount(name) {
      if (name == "轿外人数") {
        if (this.realElevatorDataList.length == 1) {
          if (
            this.realElevatorDataList[0].data &&
            this.realElevatorDataList[0].data.IsScreen
          ) {
            return this.realElevatorDataList[0].data.IsScreen == "1";
          }
        }
        return false;
      }
      return true;
    },
  },
  mounted() {
    this.$store.state.monitorStatusTimer = null;
    if (this.$store.state.allDayMonitorTimer == -1) {
      this.$store.state.allDayMonitorTimer = null;
    }
    this.allowMonitor();
    if (this.loaded) {
      this.getStatusDescData();
      let row = this.$route.query.row;
      if (row && row.jobNum) {
        this.rowDblClick(row);
      } else {
        // this.anim.stop();
        this.initData();
      }
    }
  },
  filters: {
    defaultValue: function (value) {
      if (!value) {
        return "--";
      }
      return value;
    },
    subString: function (value) {
      if (value && value.length > 7) {
        return value.substring(0, 7) + "...";
      }
      return value;
    },
    realFloor(elevator) {
      const floor = elevator.Floor;
      if (!floor || floor == "0") {
        return "";
      }
      const realFloorList = elevator.realFloorList;
      if (realFloorList != null && realFloorList.length > 0) {
        for (let i = 0; i < realFloorList.length; i++) {
          const item = realFloorList[i];
          if (item.floorcode == floor) {
            return item.description + "F";
          }
        }
      }
      return floor + "F";
    },
    otherStatusFormat(value, name) {
      if (name === "发电功率（KW）") {
        if (value == null) {
          return "";
        }
        const parsedValue = parseFloat(value);
        if (isNaN(parsedValue) || parsedValue === 0) {
          return 0;
        }
        return parsedValue.toFixed(3);
      } else {
        return value;
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    this.closeTimer();
    next();
  },
  beforeDestroy() {
    this.closeTimer();
    if (
      this.$store.state.allDayMonitorTimer &&
      this.$store.state.allDayMonitorTimer != -1
    ) {
      window.clearTimeout(this.$store.state.allDayMonitorTimer);
    }
    this.$store.state.allDayMonitorTimer = -1;
    // if (this.websocket != null) {
    //   this.websocket.close();
    // }
    if (this.$store.state.ws) {
      this.$store.state.isAutoCloseWS = false;
      this.$store.state.ws.close();
      this.$store.commit("setWS", null);
    }
  },
  activated() {
    if (
      this.loaded &&
      (!this.$store.state.monitorStatusTimer ||
        this.$store.state.monitorStatusTimer == -1)
    ) {
      this.openTimer();
    }
    if (this.$store.state.allDayMonitorTimer == -1) {
      this.$store.state.allDayMonitorTimer = null;
    }
    this.allowMonitor();
  },
  deactivated() {
    if (
      this.$store.state.allDayMonitorTimer &&
      this.$store.state.allDayMonitorTimer != -1
    ) {
      window.clearTimeout(this.$store.state.allDayMonitorTimer);
    }
    this.$store.state.allDayMonitorTimer = -1;
  },
};
</script>
<style lang="scss" scoped>
.monitor {
  /deep/ .el-dialog__body {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .export-button {
    float: right;
    border-radius: 10em;
    background-color: #ecf5ff;
    width: 80px;
  }
}
// /deep/ .el-button + .el-button {
//   margin-left: 0px;
// }
.panel-liftList {
  position: absolute;
  width: calc(100% - 50px);
  // top: 124px;
  z-index: 999;
  box-shadow: 0 10px 20px rgba(#000, 0.3);
}

@keyframes liftArrowMove {
  0% {
    transform: translateY(-10%);
  }
  50% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(10%);
  }
}

.statePanel {
  // height: 490px;
  /deep/ .panel-c {
    // border-color: rgba(#fff, 0.1);
    padding: 25px;
    overflow: hidden;
  }
  /deep/ .panel-f {
    border: 0;
    padding: 10px 25px 25px;
  }
  &-tag {
    width: 62px;
    height: 62px;
    color: $--color-primary;
    transition: all 0.2s ease;
    &.off {
      color: $--color-text-secondary;
    }
    ::v-deep path[pid="1"] {
      animation: liftArrowMove linear 1.5s infinite;
    }
  }
  // &-floor {
  //   position: absolute;
  //   // right: 0;
  //   left: 100px;
  //   top: 40px;
  //   // width: 10em;
  //   // text-align: center;
  //   font-size: $--font-size-small;
  //   color: $--color-text-secondary;
  //   em {
  //     margin: 0 5px;
  //     color: $--color-primary;
  //     font-size: $--font-size-large;
  //   }
  // }
  &-curFloor {
    color: $--color-text-secondary;
  }
  &-info {
    position: relative;
    // width: 160px;
    width: 260px;
    h2 {
      font-size: $--font-size-large;
      padding: 6px 0 12px;
      padding-right: 74px;
      border-bottom: 1px solid rgba(#000, 0.2);
    }
    b {
      font-size: 40px;
      font-weight: normal;
      color: $--color-text-primary;
    }
    span {
      flex: 1;
      font-size: $--font-size-small;
      color: $--color-text-secondary;
    }
    .longtext {
      margin-top: 15px;
      display: block !important;
      b {
        font-size: 1.3em;
      }
      span {
        display: block;
      }
    }

    .statePanel-tag {
      position: absolute;
      top: 0;
      right: 0;
    }

    &--lift {
      margin-top: 15px;
      b {
        display: block;
        font-size: $--font-size-large;
        line-height: 1;
        margin-bottom: 10px;
      }
    }
  }
  &-detail {
    border-collapse: collapse;
    // position: absolute;
    // bottom: 30px;
    width: 260px;
    &-fra {
      position: absolute;
      bottom: 15px;
      background: rgba(#fff, 0.5);
      border-radius: 20px;
      padding: 12px;
      margin: 0 -12px;
    }
    th,
    td {
      padding: 0.3em 0;
    }
    h4 {
      color: $--color-text-secondary;
      font-size: $--font-size-small;
    }
    p {
      margin-top: 2px;
      margin-right: 15px;
    }
  }
  &-btn {
    position: absolute;
    bottom: 15px;
    .el-button {
      border: 0;
    }
  }
  &-img {
    position: absolute;
    // right: 50%;
    // // top: 40px;
    // top: 50%;
    // margin-top: -120px !important;
    // margin-right: -300px !important;
    right: 45%;
    top: 50%;
    margin-top: -120px !important;
    margin-right: -260px !important;
  }
  &-imgMuti {
    position: absolute;
    // right: 50%;
    // top: 50%;
    // margin-top: -120px !important;
    // margin-right: -300px !important;
    right: 45%;
    top: 50%;
    margin-top: -120px !important;
    margin-right: -220px !important;
  }
  .floorNum {
    position: relative;
    top: 2px;
    color: $--color-primary;
    font-size: 19px;
  }
}
.stateList {
  color: $--color-text-secondary;
  font-size: 12px;
  font-size: 10px;
  h2 {
    margin-bottom: 8px;
    color: #a8a8a8;
    &::before,
    &::after {
      content: "-";
    }
  }
  &-item {
    text-align: center;
    float: left;
    min-width: 4em;
    margin-right: 30px;
    &__icon {
      width: 28px;
      height: 28px;
      padding: 5px;
      border: 1px solid #74777a;
      border-radius: 50%;
      overflow: visible;
    }
    p {
      line-height: 2;
    }
  }
  .stateList-item span {
    display: block;
    text-align: left;
    // color: $--color-text-secondary;
  }
}
.signal {
  font-size: $--font-size-small;
  color: $--color-text-placeholder;
  display: flex;
  flex-flow: column wrap;
  // justify-content: flex-start;
  height: 100%;
  width: fit-content;
  padding: 12px 20px;
  gap: 4px 25px;
  &--horizontal {
    flex-flow: row wrap;
    width: 100%;
    height: auto;
  }
  &-item {
    min-width: 200px;
    width: 10vw;
    line-height: 30px;
    padding: 0 15px;
    // margin: 2px 0;
    span {
      display: flex;
      align-items: center;
      &:before {
        content: "";
        display: inline-block;
        width: 1.1em;
        height: 1.1em;
        min-width: 1.1em;
        border-radius: 50%;
        // border: 1px solid $--border-color-base;
        background: darken($--background-color-light, 1%);
        // vertical-align: text-bottom;
        box-sizing: border-box;
        margin-right: 0.8em;
      }
    }
    &.on {
      color: $--color-text-primary;
      background: rgba(#fff, 0.8);
      border-radius: 10px;
      box-shadow: 0 0 3px 0 rgba(0, 0, 0, 0.1);
      span:before {
        background: $--color-success;
        border: 3px solid mix(#fff, $--color-success, 80%);
        box-shadow: 0 0 1px rgba($--color-success, 0.6);
      }
    }
  }
  &--primary {
    .signal-item.on {
      color: $--color-primary;
      span:before {
        background: $--color-primary;
        border: 3px solid mix(#fff, $--color-primary, 80%);
        box-shadow: 0 0 1px rgba($--color-primary, 0.6);
      }
    }
  }
  .signal-item.gray {
    color: $--color-text-primary;
    span:before {
      background: $--color-text-primary;
      border: 2px solid mix(#fff, $--color-text-primary, 60%);
    }
  }
  .signal-item.yellow {
    color: #e6a23c;
    span:before {
      background: #e6a23c;
      border: 2px solid mix(#fff, #e6a23c, 60%);
    }
  }
  .signal-item.red {
    color: $--color-primary;
    span:before {
      background: $--color-primary;
      border: 2px solid mix(#fff, $--color-primary, 60%);
    }
  }
}
.infoBlock {
  display: inline-block;
  text-align: center;
  background: #efefef;
  width: 90px;
  height: 90px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  p {
    color: $--color-primary;
    font-size: 40px;
    line-height: 1;
  }
  h4 {
    color: $--color-text-secondary;
    font-size: 11px;
  }
}
.valuePanel {
  // height: 122px;
  overflow: visible;
  &:before {
    content: "";
    position: absolute;
    top: -2px;
    left: 50%;
    transform: translateX(-50%);
    display: inline-block;
    width: 28%;
    height: 4px;
    border-radius: 10em;
    background: $--color-black;
  }
  /deep/ .panel-h {
    line-height: 38px;
    padding: 0px 10px;
    // padding: 0;
    margin-top: 6px;
    text-align: center;
    border: 0;

    &:after {
      content: "";
      position: absolute;
      bottom: 0;
      width: 80%;
      left: 10%;
      border-top: 1px solid rgba($--border-color-light, 0.5);
    }
    h2 {
      font-size: $--font-size-small;
      color: $--color-text-regular;
      font-weight: normal;
    }
  }
  /deep/ .panel-c {
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0px;
    p {
      font-size: 40px;
    }
    b {
      font-size: $--font-size-large;
      font-weight: normal;
    }
    span {
      font-size: $--font-size-small;
      color: $--color-text-secondary;
      margin-left: 5px;
    }
  }
  b {
    text-align: center;
  }
}
.alarmPanel {
  .el-button {
    position: absolute;
    bottom: 13px;
    right: 10px;
  }
}
@keyframes openDoor_l {
  0% {
    transform: translateX(0);
  }
  to {
    transform: translateX(-70px);
  }
}
@keyframes openDoor_r {
  0% {
    transform: translateX(0);
  }
  to {
    transform: translateX(70px);
  }
}
@keyframes closeDoor_l {
  0% {
    transform: translateX(-70px);
  }
  to {
    transform: translateX(0);
  }
}
@keyframes closeDoor_r {
  0% {
    transform: translateX(70px);
  }
  to {
    transform: translateX(0);
  }
}

.statePanel-img--lift {
  &.open {
    /deep/ path[pid="2"] {
      animation: openDoor_l 1s ease-in-out forwards;
    }
    /deep/ path[pid="3"] {
      animation: openDoor_r 1s ease-in-out forwards;
    }
  }
  &.close {
    /deep/ path[pid="2"] {
      animation: closeDoor_l 1s ease-in-out forwards;
    }
    /deep/ path[pid="3"] {
      animation: closeDoor_r 1s ease-in-out forwards;
    }
  }
}
.liftInset {
  position: absolute;
  width: 0px;
  height: 267px;
  top: 34px;
  left: 174px;
  background: #23272f;
  // transition: all 1s ease-in-out;
  &.open {
    width: 131px;
    left: 108px;
  }
}
.liftInsetMuti {
  position: absolute;
  width: 0px;
  height: 184px;
  top: 23px;
  left: 100px;
  background: #23272f;
  // transition: all 1s ease-in-out;
  &.open {
    width: 89px;
    left: 55px;
  }
}
.lift_transition {
  transition: all 1s ease-in-out;
}
@media screen and (max-width: 1920px) {
  .liftInsetMuti {
    height: 182px;
    top: 24px;
  }
}
// .statePanel-detail {
//   td {
//     padding-top: 2px;
//     padding-bottom: 2px;
//     p {
//       margin-top: 2px;
//       margin-bottom: 2px;
//     }
//   }
// }

@media screen and (max-width: $--lg) {
  .panel-liftList {
    width: calc(100% - 30px);
  }
}
.info-box {
  display: flex;
  flex-wrap: wrap;
  .item {
    margin: 10px 25px;
    font-size: 14px;
  }
}
.energy {
  position: absolute;
  bottom: -4px;
  display: flex;
  td {
    color: #12ad29 !important;
    font-size: 13px;
    margin-right: 20px;
  }
}
.energy-bar {
  position: absolute;
  right: 10px;
  bottom: 10px;
  display: flex;
  flex-direction: column-reverse; /* 将能量条容器的方向设置为从下到上 */
  width: 25px; /* 能量条容器的宽度 */
  height: 90px; /* 能量条容器的高度 */
  &::before {
    content: attr(title);
    position: absolute;
    top: -18px;
    left: 50%;
    transform: translate(-50%);
    font-size: 13px;
  }
}

.energy-item {
  height: 12%; /* 每格能量条的高度为总高度的10% */
  margin-top: 3px; /* 设置能量条之间的间距 */
  background-color: gray;
}

.filled {
  background-color: #47a3ea;
}
.monitor_class {
  width: 100%;
  height: 20px;
  display: flex;
  justify-content: center;
  span {
    height: 20px;
    line-height: 20px;
    display: block;
    float: left;
    color: #00a081;
  }
}

//运行图右上角的btns
.rtTools {
  position: absolute;
  right: 0;
  top: 0;
  background: $--color-primary;
  border-radius: 0 20px 0 20px;
  padding: 20px;
  .svg-icon {
    width: 24px;
    height: 24px;
    color: #fff;
    cursor: pointer;
    + .svg-icon {
      margin-left: 10px;
    }
  }
}
</style>
